import { render, staticRenderFns } from "./SalesTypeForm.vue?vue&type=template&id=30988340&scoped=true"
import script from "./SalesTypeForm.vue?vue&type=script&lang=js"
export * from "./SalesTypeForm.vue?vue&type=script&lang=js"
import style0 from "./SalesTypeForm.vue?vue&type=style&index=0&id=30988340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30988340",
  null
  
)

export default component.exports